{% block sw_theme_modal %}
<sw-modal
    class="sw-theme-modal"
    :title="$t('sw-theme-manager.themeModal.modalTitle')"
    :subtitle="$t('sw-theme-manager.themeModal.modalSubtitle')"
    @modal-close="closeModal"
>

    {% block sw_theme_modal_header %}
    <div class="sw-theme-modal__header">
        <sw-card-section class="sw-theme-modal__header-search">
            <sw-container>
                <sw-simple-search-field
                    class="sw-theme-modal__header-search"
                    variant="form"
                    :placeholder="$t('sw-theme-manager.general.placeholderSearchBar')"
                    @search-term-change="onSearch"
                />
            </sw-container>
        </sw-card-section>
    </div>
    {% endblock %}

    {% block sw_theme_modal_content %}
    <div class="sw-theme-modal__content">
        {% block sw_theme_modal_loader %}
        <sw-loader v-if="isLoading"/>
        {% endblock %}

        {% block sw_theme_modal_content %}
        <sw-container
            v-else
            columns="repeat(auto-fill, minmax(250px, 1fr))"
            gap="24px"
        >
            {% block sw_theme_modal_content_listing %}
            <div
                v-for="theme in themes"
                :key="theme.id"
                class="sw-theme-modal__content-item"
                :class="{ 'is--selected': theme.id === selected }"
            >
                {% block sw_theme_modal_content_listing_item %}

                {% block sw_theme_modal_content_listing_item_checkbox %}
                <mt-checkbox :checked="theme.id === selected" @update:checked="onSelection(theme.id)" />
                {% endblock %}

                {% block sw_theme_modal_content_listing_item_inner %}
                <sw-theme-list-item
                    :key="theme.id"
                    :theme="theme"
                    @item-click="selectItem(theme.id)"
                />
                {% endblock %}

                {% endblock %}
            </div>
            {% endblock %}
        </sw-container>
        {% endblock %}
    </div>
    {% endblock %}

    {% block sw_theme_modal_footer %}
    <template #modal-footer>
        <mt-button variant="secondary" @click="closeModal">
            {{ $t('global.default.cancel') }}
        </mt-button>
        <mt-button variant="primary" @click="selectLayout">
            {{ $t('sw-theme-manager.themeModal.actionConfirm') }}
        </mt-button>
    </template>
    {% endblock %}

</sw-modal>
{% endblock %}
